/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_Artifacts_BodyInputs */



/**
* | output |
* | --- |
* | "Documents, presentations and files the AI created for you, all in one library." |
*
* @param {Onboarding_Tour_Artifacts_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_artifacts_body = /** @type {((inputs?: Onboarding_Tour_Artifacts_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_Artifacts_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dokumente, Präsentationen und Dateien, die die KI für dich erstellt hat, in einer Bibliothek.")
	return /** @type {LocalizedString} */ ("Documents, presentations and files the AI created for you, all in one library.")
});